import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const Footer = () => {
  const { language, paths } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-[#ff5200] text-white py-12">
      <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Logo & Social */}
          <div>
            <div className="mb-6">
              <img 
                src="https://i.ibb.co/KcQQXMz3/logo-02.png" 
                alt="Pik Agency" 
                className="h-10 w-auto brightness-0 invert"
              />
            </div>
            <div className="flex items-center gap-4">
              <a
                href="mailto:hello@pikagency.de"
                className="hover:opacity-80 transition-opacity"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
              <a
                href="https://instagram.com/pikagency.de"
                className="hover:opacity-80 transition-opacity"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://linkedin.com/company/pikagency"
                className="hover:opacity-80 transition-opacity"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Offices */}
          <div>
            <h3 className="font-bold text-lg mb-4">{t.contact.offices}</h3>
            <div className="space-y-4">
              <div>
                <div className="flex items-start gap-2 mb-2">
                  <MapPin size={18} className="mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">{t.contact.frankfurtOffice}</p>
                    <p className="text-sm opacity-90">Sachsenhäuser Landwehrweg 159A</p>
                    <p className="text-sm opacity-90">60599 Frankfurt, {t.home.countries.germany}</p>
                  </div>
                </div>
              </div>
              <div>
                <div className="flex items-start gap-2">
                  <MapPin size={18} className="mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">{t.contact.istanbulOffice}</p>
                    <p className="text-sm opacity-90">Kültür mah. Suna sok. No:88</p>
                    <p className="text-sm opacity-90">34340 Istanbul, {t.home.countries.turkey}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Legal</h3>
            <div className="space-y-2">
              <Link
                to={paths.imprint}
                className="block hover:opacity-80 transition-opacity"
              >
                {t.footer.imprint}
              </Link>
              <Link
                to={paths.privacy}
                className="block hover:opacity-80 transition-opacity"
              >
                {t.footer.privacy}
              </Link>
              <Link
                to={paths.terms}
                className="block hover:opacity-80 transition-opacity"
              >
                {t.footer.terms}
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 border-t border-white/20 text-center">
          <p className="text-sm opacity-90">
            © Pik Agency 2025 – {t.footer.allRights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;